import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { SelectChangeEvent } from "@mui/material/Select";
import TableBody from "@mui/material/TableBody";
import TableList from "./TableList";
import EnhancedTableHead from "./TableHead";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetBranchQuery } from "../../../Service/branches";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";

interface Data {
  created: string;
  name: string;
  phone_number: string;
  email: string;
  city: string;
  service: string;
  status: string;
  last_contacted: string;
  last_reminder: string;

}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "asc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function DashTable({ show, setshow, setBranchDetail, branchDetail, branches }) {
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("created");



  const handleChange = (event: SelectChangeEvent) => {
  };



  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    

  };


  return (

    <div className="Enhance-table">
      <Box sx={{ width: "auto" }}>
        <Paper sx={{ width: "100%", mb: 2 }} >
          <TableContainer className="custom-tablebody">
            <Table sx={{ minWidth: 1500 }} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {branches && branches.length !== 0 && <TableList
                  customer_list={branches}
                  getComparator={getComparator}
                  order={order}
                  orderBy={orderBy}
                  stableSort={stableSort}
                  handleClick={handleClick}
                  handleChange={handleChange}
                  state={show}
                  setstates={setshow}
                  setBranchDetail={setBranchDetail}
                />}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </div>
  );
}
export default React.memo(DashTable)